/**
 * Display labels for chat agent tool-use chips.
 *
 * SINGLE SOURCE OF TRUTH: labels are defined once on the backend tool registry
 * (agent/tool_registry.py — every client tool has a required display_label) and
 * generated into `toolLabels.json`. A backend test keeps the JSON in sync with
 * the registry (regenerate with GEN_TOOL_LABELS=1). Do NOT hand-edit a map here
 * or derive a label from the tool id — add/rename the label on the registry.
 *
 * Because the generated map covers every registered tool, a live tool never
 * renders its raw name; the `|| toolName` last resort only applies to an
 * orphaned id (a removed/renamed tool in an old message).
 */
import TOOL_LABELS from './toolLabels.json';

export const formatToolName = (toolName) => TOOL_LABELS[toolName] || toolName;
